import { HttpInterceptorFn, HttpRequest, HttpHandlerFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { ConfigService } from '../core/services/config/config.service';
import { AUTH_MODE, AuthMode } from './auth.context';
import { TokenService } from '../core/services/config/token.service';

export const authInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn) => {
  const config = inject(ConfigService);
  const tokenSvc = inject(TokenService);

  let mode = req.context.get(AUTH_MODE);

  if (!req.context.has(AUTH_MODE)) {
    if (req.url.includes('/public/')) mode = AuthMode.Public;
    else mode = AuthMode.Bearer;
  }

  // Combinar la base URL automáticamente si la URL es relativa
  const fullUrl = req.url.startsWith('http') ? req.url : `${config.baseUrl}${req.url}`;

  let cloned = req.clone({ url: fullUrl });

  switch (mode) {
    case AuthMode.Public:
      break;

    case AuthMode.Bearer:
      const token = tokenSvc.access;
      if (token) {
        cloned = cloned.clone({
          setHeaders: { Authorization: `Bearer ${token}` }
        });
      }
      break;

    case AuthMode.ApiKey:
      cloned = cloned.clone({
        setHeaders: { 'x-api-key': config.apiKey }
      });
      break;
  }

  return next(cloned);
};
